import { useAtom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import { AnalyticsEvents } from '~/services/analytics';
import { FiltersScopeValue, TableAnalytics, useFilterState, useUpdateFilter } from '~/state/tableFilters';
import { DocumentType } from '~/types/document';
import { FlowStatusFilterValue, PaymentMethod } from '~/types/flow';
import { TransactionFlowDirection } from '~/types/transaction';

interface ReconcileTransactionModalFields {
  search: string;
  documentDateRange: [string | null, string | null];
  flowPaymentMethod: PaymentMethod[];
  documentType: DocumentType[];
  flowPaymentDate: [string | null, string | null];
  flowPaymentStatus: FlowStatusFilterValue | null;
  totalAmount: [number | null, number | null, TransactionFlowDirection | null];
  counterpartId: string | null;
}

const defaultValues: ReconcileTransactionModalFields = {
  search: '',
  documentDateRange: [null, null],
  flowPaymentMethod: [],
  documentType: [],
  flowPaymentDate: [null, null],
  flowPaymentStatus: null,
  totalAmount: [null, null, null],
  counterpartId: null,
};

const analytics: TableAnalytics = {
  search: AnalyticsEvents.RECONCILE_TRANSACTION_MODAL_SEARCH_BAR_USED,
  filter: AnalyticsEvents.RECONCILE_TRANSACTION_MODAL_FILTER_USED,
};

export const reconcileTransactionsFilterScopeValue: FiltersScopeValue = {
  defaultValues,
  analytics,
};

export const reconcileTransactionsFiltersStorageKey = 'reconcile-transactions-filters';

const showReconciledFlowsAtom = atomWithStorage('reconciliation-show-reconciled-flows', true);
export const useShowReconciledFlows = () => useAtom(showReconciledFlowsAtom);

export const useReconcileTransactionsFilters = () => useFilterState<ReconcileTransactionModalFields>();
export const useUpdateReconcileTransactionsFilters = () => useUpdateFilter<ReconcileTransactionModalFields>();
